/**
 * Shared emoji utility for rating visualization
 * Used by RestaurantHistory, UserRatingsTimeline, and ReportListItem components
 */

export const getEmojiForScore = (score: number): string => {
  switch (score) {
    case 1:
      return "💀"; // Worst rating
    case 2:
      return "🤮"; // Bad rating
    case 3:
      return "🙂"; // Average rating
    case 4:
      return "😃"; // Good rating
    case 5:
      return "😍"; // Best rating
    default:
      return "❓"; // Unknown rating
  }
};
